import AgGridToolingCompliance from 'Components/organisms/AgToolingComplianceGrid/AgGridToolingCompliance';
import { TOOLING_COVERAGE_PAGE } from 'Core-utils/constants/constants';
import './styles.scss';
import useTimeSpent from 'Hooks/useTimeSpent';
import { useI18n } from 'Hooks/useI18n';

const COMPONENT_IDENTIFIER = 'Tooling Coverage Page';

const ToolingCoveragePage = () => {
    const { t } = useI18n();
    useTimeSpent(COMPONENT_IDENTIFIER);

    return (
        <div className="tooling-coverage-page pt-4 pb-4 w-100 h-100 d-flex flex-column gap-2">
            <div className="tooling-coverage-page__body ">
                <AgGridToolingCompliance tableBodyHeight="100%" title={t(TOOLING_COVERAGE_PAGE)} />
            </div>
        </div>
    );
};

export default ToolingCoveragePage;
